import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';

const DonutChartAnniversary = ({ anniversaryData }) => {
    const [series, setSeries] = useState([]);
    const [chartOptions, setChartOptions] = useState({
        chart: {
            type: 'donut',
        },
        labels: [],
        legend: {
            show: false,
        },
        colors: [],
        dataLabels: {
            enabled: false,
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '70%',
                    labels: {
                        show: false,
                    },
                },
                expandOnClick: false,
            },
        },
        tooltip: {
            enabled: true,
            theme: "light",
            style: {
                fontSize: '14px',
                fontWeight: 'bold',
            },
        },
    });

    const PREDEFINED_COLORS = {
        "10 Years": '#0000a0',
        "15 Years": '#00d7b9',
        "20 Years": '#ffdc00',
        "25 Years": '#00dcfa',
        "30 Years": '#a6db00',
        "50 Years": '#9600ff',
        "70 Years": '#ff32a0',
    };

    const generateColor = (index) => {
        const colors = ['#ff5733', '#33ff57', '#3357ff', '#ff33a8', '#33fff1', '#a833ff', '#ffb833'];
        return colors[index % colors.length];
    };

    useEffect(() => {
        if (anniversaryData && Object.keys(anniversaryData).length > 0) {
            const sortedMilestones = Object.entries(anniversaryData)
                .map(([key, value]) => [parseInt(key, 10), value])
                .sort((a, b) => a[0] - b[0])
                .map(([key, value]) => [key.toString(), value]);

            const COLORS = {};
            let colorIndex = 0;
            sortedMilestones.forEach(([key]) => {
                COLORS[`${key} Years`] =
                    PREDEFINED_COLORS[`${key} Years`] || generateColor(colorIndex++);
            });

            const labels = sortedMilestones.map(([key]) => `${key} Years`);
            const data = sortedMilestones.map(([, value]) => value);

            setChartOptions((prevOptions) => ({
                ...prevOptions,
                labels,
                colors: labels.map((label) => COLORS[label]),
            }));

            setSeries(data);
        } else {
            setSeries([]);
            setChartOptions((prevOptions) => ({
                ...prevOptions,
                labels: [],
                colors: [],
            }));
        }
    }, [anniversaryData]);

    return (
        <div
            id="donut-chart-anniversary"
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: series.length === 0 ? 'center' : undefined,
                height: '360px',
            }}
        >
            {series.length > 0 ? (
                <ReactApexChart
                    options={chartOptions}
                    series={series}
                    type="donut"
                    height={window.innerWidth <= 425 ? 200 : 320}
                    width={window.innerWidth <= 425 ? 250 : 520}
                />
            ) : (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '50vh',
                        fontSize: '18px',
                        color: '#666',
                        textAlign: 'center',
                    }}
                >
                    No data is available.
                </div>
            )}
    
            {series.length > 0 && (
                <div
                    style={{
                        marginTop: '20px',
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'center',
                    }}
                >
                    {chartOptions.labels.map((label, index) => (
                        <div
                            key={index}
                            style={{
                                display: 'flex',
                                alignItems: 'stretch',
                                margin: '5px 15px',
                            }}
                        >
                            <span
                                style={{
                                    width: '15px',
                                    height: '15px',
                                    backgroundColor: chartOptions.colors[index],
                                    marginRight: '8px',
                                    borderRadius: '3px',
                                }}
                            ></span>
                            <span
                                style={{
                                    fontSize: '14px',
                                    color: '#333',
                                }}
                            >
                                {label}:{' '}
                                {(
                                    (series[index] /
                                        series.reduce((a, b) => a + b, 0)) *
                                    100
                                ).toFixed(1)}
                                %
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );    
};

export default DonutChartAnniversary;
